import { DestinationListItemType } from "../../types";

export type TowToLocationType = {
  geometry: {
    location: {
      lat: number;
      lng: number;
    };
    viewport: any;
  };
  icon: string | null;
  id: string;
  name: string;
  photos: any | null;
  reference: string;
  scope: string;
  types: string[];
  vicinity: string;
  towCost: number | null;
  isSecureFacility: boolean;
  secureFacilityDetails: any | null;
  isPreferredDealer: boolean;
  totalMiles: number;
  opening_hours: {
    openfrom: string;
    closeat: string;
  };
  place_id: string;
  plus_code: any | null;
  html_attributions: string[];
  bizName: string;
  dealerId: string;
  towInfo: {
    distanceFromCurrentLocation: number;
    distanceUnits: string;
    unitsShorthand: string;
    overMileageDistance: string;
    overMileageCost: string;
    totalTowCost: string;
  };
  operatingHours: {
    status: string;
    text: string;
  };
};

export const mapDestinationForUpdateLocation = (customDestination: DestinationListItemType, towDestination: TowToLocationType) => {
  return {
    // address_components:

    business_status: "OPERATIONAL",

    formatted_address: customDestination.searchableName || towDestination.vicinity,

    formatted_phone_number: customDestination.contactNumber,

    geometry: {
      location: {
        lat: Number(customDestination.latitude) || towDestination.geometry?.location?.lat,
        lng: Number(customDestination.longitude) || towDestination.geometry?.location?.lng
      }
    },

    name: customDestination.name || towDestination.name,

    // Not a real Google place_id
    place_id: towDestination.place_id,


    rating: null,

    types: towDestination.types || [],

    user_ratings_total: null,

    vicinity: towDestination.vicinity,

    website: null,

    html_attributions: towDestination.html_attributions || [],

    utc_offset_minutes: null,

    addressDetails: {
      addressLine1: customDestination.street,
      city: customDestination.cityName,
      country: customDestination.countrtyCd,
      latitude: customDestination.latitude,
      longitude: customDestination.longitude,
      state: customDestination.stateCd,
      zipCode: customDestination.zipCd,
      bizName: customDestination.dealerDisplayName,
      dealerId: customDestination.dealerId
    },

    towInfo: {
      distanceFromCurrentLocation: String(
        towDestination.towInfo?.distanceFromCurrentLocation ?? customDestination.totalMiles
      ),
      distanceUnits: towDestination.towInfo?.distanceUnits || "mile",
      unitsShorthand: towDestination.towInfo?.unitsShorthand || "mi",
      overMileageDistance: towDestination.towInfo?.overMileageDistance || "0.0",
      overMileageCost: towDestination.towInfo?.overMileageCost || "0.00",
      totalTowCost: towDestination.towInfo?.totalTowCost || "0.00"
    },

    operatingHours: {
      status: towDestination.operatingHours?.status,
      text: towDestination.operatingHours?.text,
    }
  };
}
